import { useEffect, useRef } from "react";
// vite-plugin-pwa v1.x always exposes this virtual module
import { registerSW } from "virtual:pwa-register";
import { toast } from "@/components/ui/sonner";

/**
 * Ensures users on the published site are prompted to refresh when a new build is available.
 * This prevents running stale cached JS (common on iOS/PWA).
 */
export function PWAUpdatePrompt() {
  const hasPromptedRef = useRef(false);

  useEffect(() => {
    const updateServiceWorker = registerSW({
      onNeedRefresh() {
        // Avoid duplicate prompts if multiple SW events fire.
        if (hasPromptedRef.current) return;
        hasPromptedRef.current = true;

        toast("Update available", {
          description: "Refresh to get the latest fixes.",
          duration: Infinity,
          action: {
            label: "Refresh",
            onClick: () => updateServiceWorker(true),
          },
        });
      },
    });

    return () => {
      // no-op: updateServiceWorker has no unsubscribe in this API
    };
  }, []);

  // Reset the prompt flag after a while (in case the user ignores it for a long time).
  useEffect(() => {
    const t = window.setTimeout(() => {
      hasPromptedRef.current = false;
    }, 60_000);
    return () => window.clearTimeout(t);
  }, []);

  return null;
}
